<template>
  <div id="app" class="app-wrapper"
    v-bind:class="{'kz_bg': ($country == 'kz'), 'ru_bg': ($country == 'ru')}">
    <Dasboard/>

    <script type="application/javascript" src="./auto-scaler.js"
    wrapper-classname="app-wrapper" width="1920" height="1080"></script>
  </div>
</template>

<script>

import Dasboard from '@/views/Dashboard.vue';

export default {
  name: 'App',
  components: { Dasboard },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 1920px;
  height: 1080px;
  display: flex;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.ru_bg {
  background: url('assets/images/RU/background.png');
  }

.kz_bg {
  background: url('assets/images/KZ/background.png');
  }
</style>
